import { DataSource } from 'app/components';
import { IDataPointExt, ISeries } from 'app/components/data/DataChart/interfaces'
import { ObjectParser } from 'app/components/data/utils'
import * as Highcharts from 'highcharts'
import * as _ from 'lodash'
import * as React from 'react'
import * as ReactHighcharts from 'react-highcharts'
import './config'

export interface IDataChartProps {
  config: Highcharts.Options
  series: ISeries[],
  datasource?: DataSource<any>
}

export interface IDataChartState {
  config: Highcharts.Options
}

export class DataChart extends React.Component<IDataChartProps, IDataChartState> {
  state = {
    config: null
  }

  private unlistenFuncs: Array<() => void> = []

  getRecordsAndSetSeries() {
    if (!this.props.datasource) {
      return
    }

    this.removeDataSourceListeners()

    const chart = this.getChartObject()

    chart.showLoading()

    const unlisten = this.props.datasource.onSync((records) => {
      this.props.series.forEach((series, index) => {
        const parsedSeries = ObjectParser.QueryISeriesWithLoop(records, series)

        //NOTE: Reset series object
        this.state.config.series[index] = {}

        //NOTE: Set series object with parsed series object
        Object.keys(parsedSeries).forEach((key) => {
          this.state.config.series[index][key] = parsedSeries[key]
        })
      })

      //NOTE: Update state with new series
      this.setState({ config: { ...this.state.config } })
    })

    this.props.datasource.sync()

    this.unlistenFuncs.push(unlisten)
  }

  updateSeries(props: IDataChartProps) {
    this.getRecordsAndSetSeries()
  }

  removeDataSourceListeners() {
    this.unlistenFuncs.forEach((unlisten) => unlisten())
    this.unlistenFuncs = []
  }

  getChartObject() {
    const chartRef: any = this.refs.chart
    const chart: Highcharts.ChartObject = chartRef ? chartRef.getChart() : {}

    return chart
  }

  componentWillReceiveProps(nextProps: IDataChartProps) {
    if (!_.isEqual(this.props, nextProps)) {
      this.updateSeries(nextProps)
    }
  }

  componentWillMount() {
    this.state.config = { ...this.props.config }
    this.state.config.series = this.state.config.series || []
    this.state.config.title = this.state.config.title || {}
    this.state.config.title.text = this.state.config.title.text || ''

    this.setState({ config: this.state.config }, () => {
      this.updateSeries(this.props)
    })
  }

  componentWillUnmount() {
    this.removeDataSourceListeners()
  }

  //Animation Kluge
  //https://github.com/kirjs/react-highcharts/issues/171
  componentDidUpdate() {
    const chart = this.getChartObject()
    const chartReflow = chart.reflow
    chart.reflow = () => { /* */ }
    setTimeout(() => (chart.reflow = chartReflow))
  }

  render() {
    return (
      <ReactHighcharts config={this.state.config} ref="chart" />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataChart/index.tsx